"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var abstract_criterion_value_1 = require("./abstract-criterion-value");
var criterion_helper_1 = require("../helper/criterion-helper");
/**
 * For timeline category 'current', 'last', 'next' etc.
 */
var CriterionNumber = /** @class */ (function (_super) {
    __extends(CriterionNumber, _super);
    function CriterionNumber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CriterionNumber.prototype, "value", {
        get: function () {
            return this.getValue();
        },
        set: function (value) {
            this.setValue(criterion_helper_1.CriterionHelper.ifNumber(value));
        },
        enumerable: true,
        configurable: true
    });
    return CriterionNumber;
}(abstract_criterion_value_1.AbstractCriterionValue));
exports.CriterionNumber = CriterionNumber;
//# sourceMappingURL=criterion-number.js.map